import MessagesNavigationItem from './MessagesNavigationItem';

export default MessagesNavigationItem;
